const pick = require('@sigma-legacy-libs/no-lodash/lib/pick')

const pickKVgenVariables = (schema, keys = []) => {
  const picks = [
    ...keys.map(key => `$default.${key}`),
    '$render.type',
    '$render.key',
    '$render.value.type',
    ...keys.map(key => `$render.value.variables.${key}`),
    '$render.locked'
  ]

  return Object.assign(pick(schema, picks), {
    $handler(v, s) {
      return pick(schema.$handler.call(this, v, s), keys)
    }
  })
}

const pickKVV = (schema, keys = []) => {
  const picks = [ ...keys.map(key => `$default.${key}`), '$render.type', ...keys.map(key => `$render.variables.${key}`) ]

  return Object.assign(pick(schema, picks), {
    $handler(v, s) {
      return pick(schema.$handler.call(this, v, s), keys)
    }
  })
}

exports.pickKVgenVariables = pickKVgenVariables
exports.pickKVV = pickKVV
